export const ANNUAL_REFERRAL_LIMIT = 5;
